import React from 'react'

import withDefaultStyles from './withDefaultStyles'

const FillSendWithBg = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
    <rect width="32" height="32" rx="13" fill="var(--themis-insight-icon-bg, #2F354A)" />
    <path
      d="M21.7475 13.2852L15.0527 9.95577C10.5557 7.71544 8.70989 9.55127 10.9623 14.0242L11.6428 15.3777C11.8383 15.7744 11.8383 16.2334 11.6428 16.6301L10.9623 17.9758C8.70989 22.4487 10.5478 24.2846 15.0527 22.0442L21.7475 18.7148C24.7508 17.2213 24.7508 14.7787 21.7475 13.2852ZM19.2214 16.5834H14.998C14.6773 16.5834 14.4114 16.3189 14.4114 16C14.4114 15.6811 14.6773 15.4166 14.998 15.4166H19.2214C19.542 15.4166 19.8079 15.6811 19.8079 16C19.8079 16.3189 19.542 16.5834 19.2214 16.5834Z"
      fill="var(--themis-insight-icon-fg, #ffffff)"
    />
  </svg>
)

export default withDefaultStyles(FillSendWithBg)
